import { CustomReportConfig } from 'Types/Reports.types';
import { ReportFilterOperator, USER_ENTITY } from 'Types/ReportField.types';

//
// basic request to get users and managers that are not automated
//
export const USER_ESSENTIALS_REPORT_CONFIG: CustomReportConfig = {
  entity: USER_ENTITY,
  columns: [
    { key: 'user', field: { id: 'user.id' } },
    { key: 'manager', field: { id: 'user.manager' } }
  ],
  filter: {
    operator: 'And',
    conditions: [
      {
        field: { id: 'user.is_auto' },
        operator: ReportFilterOperator.Equal,
        value: false,
        values: null
      }
    ]
  },
  arguments: {}
};
